import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import { danger, gray, primary } from "../../colors";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import Vu from "../custom/Vu";

export default function AnswerReviewItem({ number, onPress, text, answer }) {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        width: "100%",
        minHeight: 150,
        borderWidth: 1,
        borderColor: answer === undefined ? danger : primary,
        borderRadius: 10,
        padding: 10,
        marginVertical: 7,
      }}
    >
      <Vu
        style={{
          borderRadius: 100,
          width: 35,
          height: 35,
          borderWidth: 1,
          borderColor: primary,
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <MyText>{`${number}`}</MyText>
      </Vu>
      <MyText
        fontFamily={"vazir"}
        style={{ marginVertical: 10, marginHorizontal: 10 }}
      >
        {text}
      </MyText>
      <View style={{ flex: 1 }}></View>
      <Vu style={{ flexDirection: "row", alignItems: "center" }}>
        <MyText style={{ color: primary, fontSize: 18 }}>{`${translate(
          "answer"
        )} : `}</MyText>
        <MyText
          fontFamily={"vazir"}
          style={{
            fontSize: 15,
            fontWeight: "bold",
            color: answer === undefined ? danger : gray,
          }}
        >
          {answer === undefined
            ? translate("no answer to this question")
            : answer.answer}
        </MyText>
      </Vu>
    </TouchableOpacity>
  );
}
